"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.SfIconRightBottom = exports.SfIconRightCenter = exports.SfIconRightTop = exports.SfIconCenterBottom = exports.SfIconCenterCenter = exports.SfIconCenterTop = exports.SfIconLeftBottom = exports.SfIconLeftCenter = exports.SfIconLeftTop = exports.SfIconAlignHorizontalEnd = exports.SfIconAlignHorizontalCenter = exports.SfIconAlignHorizontalStart = exports.SfIconAlignEnd = exports.SfIconAlignCenter = exports.SfIconAlignStart = exports.SfIconBin = exports.SfIconSpacer = exports.SfIconCode = exports.SfIconVideo = exports.SfIconImage = exports.SfIconButton = exports.SfIconText = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var _io = require("react-icons/io5");

var __jsx = _react["default"].createElement;

var SfIconText = __jsx(_react2.Icon, {
  fontSize: "1.5rem",
  color: "yellow.500",
  as: _io.IoTextOutline
});

exports.SfIconText = SfIconText;

var SfIconButton = __jsx(_react2.Icon, {
  fontSize: "1.5rem",
  color: "yellow.500",
  as: _io.IoLinkOutline
});

exports.SfIconButton = SfIconButton;

var SfIconImage = __jsx(_react2.Icon, {
  fontSize: "1.5rem",
  color: "yellow.500",
  as: _io.IoImageOutline
});

exports.SfIconImage = SfIconImage;

var SfIconVideo = __jsx(_react2.Icon, {
  fontSize: "1.5rem",
  color: "yellow.500",
  as: _io.IoVideocamOutline
});

exports.SfIconVideo = SfIconVideo;

var SfIconCode = __jsx(_react2.Icon, {
  fontSize: "1.5rem",
  color: "yellow.500",
  as: _io.IoCodeSlashOutline
});

exports.SfIconCode = SfIconCode;

var SfIconSpacer = __jsx(_react2.Icon, {
  fontSize: "1.5rem",
  color: "yellow.500",
  as: _io.IoSwapVerticalOutline
});

exports.SfIconSpacer = SfIconSpacer;

var SfIconBin = __jsx(_react2.Icon, {
  fontSize: "2.75rem",
  color: "yellow.500",
  as: _io.IoTrashOutline
});

exports.SfIconBin = SfIconBin;

var SfIconAlignStart = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "13.5",
  y: "5.5",
  width: "8",
  height: "16"
}), __jsx("path", {
  d: "M0 2.5L24 2.5"
}), __jsx("rect", {
  x: "2.5",
  y: "5.5",
  width: "8",
  height: "10"
}));

exports.SfIconAlignStart = SfIconAlignStart;

var SfIconAlignCenter = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "13.5",
  y: "3.5",
  width: "8",
  height: "17"
}), __jsx("path", {
  d: "M0 11.5L24 11.5"
}), __jsx("rect", {
  x: "2.5",
  y: "6.5",
  width: "8",
  height: "11"
}));

exports.SfIconAlignCenter = SfIconAlignCenter;

var SfIconAlignEnd = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "13.5",
  y: "2.5",
  width: "8",
  height: "16"
}), __jsx("path", {
  d: "M0 21.5L24 21.5"
}), __jsx("rect", {
  x: "2.5",
  y: "8.5",
  width: "8",
  height: "10"
}));

exports.SfIconAlignEnd = SfIconAlignEnd;

var SfIconAlignHorizontalStart = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("path", {
  d: "M2.5 0V24"
}), __jsx("rect", {
  x: "5.5",
  y: "13.5",
  width: "10",
  height: "8"
}), __jsx("rect", {
  x: "5.5",
  y: "2.5",
  width: "16",
  height: "8"
}));

exports.SfIconAlignHorizontalStart = SfIconAlignHorizontalStart;

var SfIconAlignHorizontalCenter = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("path", {
  d: "M11.5 0V24"
}), __jsx("rect", {
  x: "6.5",
  y: "13.5",
  width: "11",
  height: "8"
}), __jsx("rect", {
  x: "3.5",
  y: "2.5",
  width: "17",
  height: "8"
}));

exports.SfIconAlignHorizontalCenter = SfIconAlignHorizontalCenter;

var SfIconAlignHorizontalEnd = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("path", {
  d: "M21.5 0V24"
}), __jsx("rect", {
  x: "8.5",
  y: "13.5",
  width: "10",
  height: "8"
}), __jsx("rect", {
  x: "2.5",
  y: "2.5",
  width: "16",
  height: "8"
}));

exports.SfIconAlignHorizontalEnd = SfIconAlignHorizontalEnd;

var SfIconLeftTop = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "4",
  y: "4",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconLeftTop = SfIconLeftTop;

var SfIconLeftCenter = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "4",
  y: "8",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconLeftCenter = SfIconLeftCenter;

var SfIconLeftBottom = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "4",
  y: "12",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconLeftBottom = SfIconLeftBottom;

var SfIconCenterTop = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "9",
  y: "4",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconCenterTop = SfIconCenterTop;

var SfIconCenterCenter = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "9",
  y: "8",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconCenterCenter = SfIconCenterCenter;

var SfIconCenterBottom = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "9",
  y: "12",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconCenterBottom = SfIconCenterBottom;

var SfIconRightTop = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "14",
  y: "4",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconRightTop = SfIconRightTop;

var SfIconRightCenter = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "14",
  y: "8",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconRightCenter = SfIconRightCenter;

var SfIconRightBottom = __jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, __jsx("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  stroke: "currentColor"
}), __jsx("rect", {
  x: "14",
  y: "12",
  width: "6",
  height: "8",
  fill: "currentColor"
}));

exports.SfIconRightBottom = SfIconRightBottom;